import { MetaModel } from "common/models/utility-models/base-model";
import { FormMetaModel, SmBtnMetaModel, SmCheckboxModel } from "common/models/utility-models/meta-model";


export class RegisterStep5MetaModel extends FormMetaModel {
    constructor() {
        super('', "", "", 3,'',true,);
        // super('Ragister', "", ROUTE_PATH.register, 3,'', true,'', 'row align-items-start justify-content-start');
    }
    
    override initProperties(): any {
        const formInfo = super.initProperties();
        const isTermsAgreed = new SmCheckboxModel(
            'isTermsAgreed',
            'isTermsAgreed',
            'checkbox',
            false,
            'col-12',
            1,
            4,
            '',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false
        );

return{
    formInfo,
    isTermsAgreed
}
    }
    
}